<template>
    <div class="rightbuttons">
        <Button icon="pi pi-eye" id="onoffneighbourlayeron" v-if="isApprovedNeighbourSiteOn == false"
            v-tooltip="'Switch on/off neighbour layer'" @click="switchNeighbourLayers" class="button1">
        </Button>
        <Button icon="pi pi-eye-slash" id="onoffneighbourlayeroff" v-if="isApprovedNeighbourSiteOn"
            v-tooltip="'Switch on/off neighbour layer'" @click="switchNeighbourLayers" class="button1">
        </Button>

    </div>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
export default {
    name: 'RightButtons',
    data() {
        return {
            isApprovedNeighbourSiteOn: false,
        }
    },
    computed: {
        isApprovedNeighbourSiteLoaded() {
            return MapOL.IsApprovedNeighbourLayersLoaded();
        }
    },
    methods: {
        switchNeighbourLayers() {
            //console.log(this.isApprovedNeighbourSiteOn);
            MapOL.SwitchNeibourLayer(this.isApprovedNeighbourSiteOn);
            this.isApprovedNeighbourSiteOn = !this.isApprovedNeighbourSiteOn;
        }
    }
}
</script>

<style lang="less" scoped>
.rightbuttons {
    position: fixed;
    right: 15px;

    .button1 {
        top: 90px;
        width: 32px;
        height: 32px;
    }
}
</style>